export default __webpack_public_path__ + "static/media/5.ca06aa36.jpg";